module.exports = __webpack_public_path__ + "img/Complicated_Plan-Brian-Valezap-Paizo.f9b45eba.jpg";